import React from "react";

import '../../styles/tarjetaContenedor.css'
import '../../styles/login.css'

const Mantenimiento = () => {
  return (
    <>
        <div className='cuerpoLogin'>
                <div className="login">
                    <form id="msform">
                        <h2 className="itemblogTitle">¡Lamentamos las molestias!</h2>
                        <br />
                        <h3 className="info_itemblog">Sitio en mantenimiento</h3>
                        <br />
                        <h3 className="info_itemblog">Gracias por su comprensión</h3>
                        <br />
                        <br />
                    </form>
                </div>
            </div>
    </>
  );
};

export default Mantenimiento;